import React, { useEffect, useState } from 'react';
import { PurchaseOrderByPurchaseId } from '../../../Redux/action/PurchaseOrderAction';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import VideoModal from '../../Candidate/CandidateDashboard/VideoModal';
import Modal from '../../Common/Modal/Modal';
import { Change_Acceptance_Status } from '../../../Redux/action/VendorDashboardAction';
import { ToastContainer, toast } from 'react-toastify';
import { SpinLoader } from '../ImportCandidates';

import './PurchaseOrderDetails.css'; // Import CSS file
import BackButton from '../../Common/BackButton/BackButton';
import Loader from '../../Common/Loader/loader';

const PurchaseOrderDetails = () => {
  const [AcceptanceStatus, setAcceptanceStatus] = useState('');
  const [remark, setRemark] = useState(null);
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location?.search);
  const id = queryParams.get('purchaseOrderId');
  const purchaseArray = useSelector((state) => state?.PurchaseOrderDetails?.result);
  const loadingPage = useSelector((state) => state?.PurchaseOrderDetails?.loading);
  const purchaseOrderArray = purchaseArray ? [purchaseArray] : [];

  useEffect(() => {
    dispatch(PurchaseOrderByPurchaseId(id));
  }, [dispatch, id]);

  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showOpen, setShowOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const handleClose = () => setShowModal(false);
  const handleCloseOpen = () => setShowOpen(false);

  const handleChange = (e) => {
    e.preventDefault();
    setLoading(true);

    dispatch(Change_Acceptance_Status(id, AcceptanceStatus, remark))
      .then((res) => {
        setLoading(false);
        if (res?.data) {
          toast.success('Acceptance Status Changed Successfully');
          setTimeout(() => {
            setShowOpen(false);
            setAcceptanceStatus('');
            setRemark(null);
            dispatch(PurchaseOrderByPurchaseId(id));
          }, 1000);
        }
      })
      .catch(() => setLoading(false));
  };

  if (loadingPage) {
    return (
      <div style={{ height: "70vh", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Loader />
      </div>
    )
  }

  return (
    <div className="pod-container">
      
      <ToastContainer />
     <div
  className="container d-flex justify-content-between align-items-center flex-wrap"
  style={{
    marginLeft:
      window.innerWidth < 640
        ? "-10px" 
        : window.innerWidth >= 640 && window.innerWidth < 1024
        ? "2px" 
        : "50px",
  }}
>
  <BackButton />
</div>

      {purchaseOrderArray.map((detail) => (
        <div key={detail?.purchaseOrderId} className="pod-inner-container">
          <div className="pod-card">
            <div className="pod-header">
              <p className="pod-title">
                {detail?.purchaseOrderType === 'CLIENT_ORDER' ? 'Client Order Details' : 'Supplier Order Details'}
              </p>
              {detail?.purchaseOrderAcceptanceStatus === 'PENDING' && (
                <button
                  onClick={() => setShowOpen(true)}
                  className="pod-button"
                >
                  Change Status
                </button>
              )}
            </div>

            <hr className="pod-divider" />

            {/* Responsive details grid */}
            <div className="pod-details-grid">
              {[
                { label: 'Order Id', value: detail?.purchaseOrderId },
                { label: 'Start Date', value: detail?.startDate },
                { label: 'Duration', value: detail?.duration ?? 'N/A' },
                { label: 'Working Hour', value: detail?.workingHours ?? 'N/A' },
                { label: 'Work Type', value: detail?.workType ?? 'N/A' },
                {
                  label: 'Work Location',
                  value: detail?.workType !== 'REMOTE' ? detail?.city + ", " + detail?.country : 'N/A',
                },
                { label: 'Billing Hours', value: detail?.minimumBillingHours ?? 'N/A' },
                { label: 'Billing Interval', value: detail?.billingInterval ?? 'N/A' },
                {
                  label: 'Purchase Amount',
                  value: `${detail?.totalAmount ?? 'N/A'} ${detail?.currency ?? ''}`,
                },
                { label: 'Remark', value: detail?.remark ?? 'N/A' },
                {
                  label: 'Purchase Order Type',
                  value: detail?.purchaseOrderType?.split('_').join(' ') ?? 'N/A',
                },
                {
                  label: 'Acceptance Status',
                  value: (
                    <span
                      className={`pod-status ${detail?.purchaseOrderAcceptanceStatus === 'ACCEPTED' ? 'pod-status-accepted' : 'pod-status-pending'}`}
                    >
                      {detail?.purchaseOrderAcceptanceStatus ?? 'N/A'}
                    </span>
                  ),
                },
                {
                  label: 'Created Date',
                  value: detail?.createdAt
                    ? new Date(detail?.createdAt).toLocaleDateString("en-GB")
                    : 'N/A',
                },
                {
                  label: 'Purchase Order Documents',
                  value: (
                    <button
                      onClick={() => setShowModal(true)}
                      className="pod-link-button"
                    >
                      Link
                    </button>
                  ),
                },
                { label: 'Time Zone', value: detail?.timeZone ?? 'N/A' },
              ].map(({ label, value }, idx) => (
                <div
                  key={idx}
                  className="pod-detail-row"
                >
                  <div className="pod-detail-label">{label}:</div>
                  <div className="pod-detail-value">{value}</div>
                </div>
              ))}
            </div>
          </div>
          {/* Video Modal */}
          <VideoModal
            showModal={showModal}
            handleClose={handleClose}
            title="Purchase Order Documents"
            newWindow={true}
            resumeUrl={detail?.purchaseOrderUrl}
            body={
              <div className="pod-video-modal-content">
                {isLoading && (
                  <div className="pod-loader">
                    <SpinLoader />
                  </div>
                )}
                {detail?.purchaseOrderUrl ? (
                  detail.purchaseOrderUrl.endsWith('.pdf') ? (
                    <iframe
                      src={detail.purchaseOrderUrl}
                      title="Purchase Order PDF"
                      className="pod-iframe"
                      onLoad={() => setIsLoading(false)}
                      style={{ display: isLoading ? 'none' : 'block' }}
                      frameBorder="0"
                    />
                  ) : (
                    <img
                      src={detail.purchaseOrderUrl}
                      alt="Purchase Order"
                      className="pod-image"
                      onLoad={() => setIsLoading(false)}
                      style={{ display: isLoading ? 'none' : 'block' }}
                    />
                  )
                ) : (
                  <p>No file available.</p>
                )}
              </div>
            }
          />

          {/* Change Acceptance Status Modal */}
          <Modal style={{ zIndex: 99 }} isOpen={showOpen} className='custom-responsive-modal' onClose={handleCloseOpen}>
            <p className="pod-modal-title">Change Acceptance Status</p>
            <hr />
            <form
              onSubmit={handleChange}
              className="pod-form"
            >
              <div>
                <label htmlFor="acceptanceStatus" className="pod-label">
                  Acceptance Status
                </label>
                <select
                  id="acceptanceStatus"
                  className="pod-select"
                  required
                  value={AcceptanceStatus}
                  onChange={(e) => {
                    const value = e.target.value;
                    setAcceptanceStatus(value);
                    setRemark('');
                  }}
                >
                  <option value="" disabled>
                    Select
                  </option>
                  <option value="ACCEPTED">ACCEPT</option>
                  <option value="REJECTED">REJECT</option>
                  <option value="REQUEST_TO_CHANGE">REQUEST TO CHANGE</option>
                </select>
              </div>

              <div>
                <label htmlFor="remark" className="pod-label">
                  Reason
                </label>
                <textarea
                  id="remark"
                  className="pod-textarea"
                  placeholder="Enter your reason to reject the acceptance status"
                  required={AcceptanceStatus !== 'ACCEPTED'}
                  disabled={AcceptanceStatus === 'ACCEPTED'}
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                />
              </div>

              <div className="pod-button-container">
                <button
                  type="submit"
                  disabled={loading}
                  className="pod-submit-button"
                >
                  {loading ? 'Please wait...' : 'Save'}
                </button>
              </div>
            </form>
          </Modal>
        </div>
      ))}
    </div>
  );
};

export default PurchaseOrderDetails;
